import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { MessageCircle, MessageSquare } from 'lucide-react';
import { motion } from 'framer-motion';

const FloatingActions = () => {
  const { api } = useAuth();
  const [settings, setSettings] = useState({ upline_whatsapp: '', telegram_link: '' });
  const [uplineContact, setUplineContact] = useState(null);

  useEffect(() => {
    fetchSettings();
    fetchUplineContact();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await api.get('/api/settings');
      setSettings(response.data);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  const fetchUplineContact = async () => {
    try {
      const response = await api.get('/api/users/upline/contact');
      setUplineContact(response.data);
    } catch (error) {
      console.error('Error fetching upline contact:', error);
    }
  };

  const handleWhatsAppClick = () => {
    const whatsapp = uplineContact?.whatsapp || settings.upline_whatsapp;
    if (whatsapp) {
      window.open(`https://wa.me/${whatsapp}`, '_blank');
    } else {
      alert('WhatsApp do master não configurado');
    }
  };

  const handleTelegramClick = () => {
    if (settings.telegram_link) {
      window.open(settings.telegram_link, '_blank');
    } else {
      alert('Link da comunidade não configurado');
    }
  };

  return (
    // Apenas visível em desktop (hidden em mobile/tablet)
    <div className="hidden lg:flex fixed bottom-8 right-8 z-40 flex-col gap-4">
      {/* Botão WhatsApp */}
      <motion.button
        whileHover={{ scale: 1.1, y: -2 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleWhatsAppClick}
        className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white rounded-full shadow-2xl hover:shadow-green-500/50 transition-all duration-300 flex items-center justify-center group relative ring-2 ring-green-400/20 hover:ring-green-400/40"
        style={{
          boxShadow: '0 8px 16px -4px rgba(34, 197, 94, 0.4), 0 0 0 1px rgba(255,255,255,0.1) inset'
        }}
        title={`Contato Master${uplineContact?.upline_username ? ` (${uplineContact.upline_username})` : ''}`}
      >
        <MessageCircle size={20} strokeWidth={2.5} />
        
        {/* Tooltip */}
        <div className="absolute right-16 bg-gray-900 text-white text-xs px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-xl">
          Contato Master
        </div>
      </motion.button>

      {/* Botão Telegram */}
      <motion.button
        whileHover={{ scale: 1.1, y: -2 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleTelegramClick}
        className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-full shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 flex items-center justify-center group relative ring-2 ring-blue-400/20 hover:ring-blue-400/40"
        style={{
          boxShadow: '0 8px 16px -4px rgba(59, 130, 246, 0.4), 0 0 0 1px rgba(255,255,255,0.1) inset'
        }}
        title="Comunidade"
      >
        <MessageSquare size={20} strokeWidth={2.5} />
        
        {/* Tooltip */}
        <div className="absolute right-16 bg-gray-900 text-white text-xs px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-xl">
          Comunidade
        </div>
      </motion.button>
    </div>
  );
};

export default FloatingActions;
